import { noop } from '@kofno/piper';
import { MutableRefObject } from 'react';
import { fromNullableT } from '../../../TaskExt';

export const isScrolledToBottom = (element: HTMLDivElement) =>
  element.scrollTop + element.clientHeight >= element.scrollHeight - 1;

export const scrollElementToBottom = (element: HTMLDivElement) => {
  element.scrollTop = element.scrollHeight;
};

export const smoothScrollToBottom = (
  messagesEndRef: MutableRefObject<HTMLDivElement | null>,
  options: ScrollIntoViewOptions = { behavior: 'smooth' },
) => {
  fromNullableT(messagesEndRef.current).fork(noop, (element) => element.scrollIntoView(options));
};

export const autoScrollIfNeeded = (
  isAutoScrollEnabled: boolean,
  messagesEndRef: MutableRefObject<HTMLDivElement | null>,
  options?: ScrollIntoViewOptions,
) => {
  if (isAutoScrollEnabled) {
    smoothScrollToBottom(messagesEndRef, options);
  }
};
